import en from './languages/en';
import pt from './languages/pt';
import es from './languages/es';

export default {
  es,
  en,
  pt,
};
